import React, { useState } from 'react'
import PropTypes from 'prop-types'
import CustomModal  from './CustomModal';
import { SimpleButton }  from '../buttons/SimpleButton';            
import isEmail from 'validator/lib/isEmail';
import { prtStart, prtInput, prtMsg, prtVar, prtErr }   from  '../../utils/prt';

const FN = "EmailModal.js";
const TRACE = false;

let initialFormState = {email: ''};


const EmailModal = ({showModal, closeHandler, submitFormHandler, cancelHandler, title}) => {

    const [formData,  setFormData]  = useState(initialFormState);
    const [formError, setFormError] = useState(initialFormState);

    const handleChange = ({target}) => {
        // TRACE && prtStart(FN, "handleChange");
        // TRACE && prtInput("target.name", target.name);
        // TRACE && prtInput("target.value",target.value);
        setFormData({...formData, [target.name]: target.value}) 
    }

    const handleCancel = () => {
        // TRACE && prtStart(FN, "handleCancel");
        /* If true, use parent's cancel callback, otherwise use their close closback  
           This makes cancel call back optional. Parent can close for both cancel and close */
        if (cancelHandler) {    
            setFormData(initialFormState);   /* in event there was a previous error, lets clear it out */
            setFormError(initialFormState);  /* in event there was a previous error, lets clear it out */
            /* fire off Parent's callback  close handler*/
            cancelHandler();    /* call parent's cancel handler */
        } else {
            handleClose();    /* call parent's close handler by calling handleClose() */
        }
    }

    const handleClose = () => {
        /* clear state */
        setFormData(initialFormState);   /* in event there was a previous error, lets clear it out */
        setFormError(initialFormState);  /* in event there was a previous error, lets clear it out */
        /* fire off Parent's callback  close handler*/
        closeHandler(); 
    }

    const handleSubmit = (e) => {
        //TRACE  &&  prtStart(FN, "handleSubmit")
        e.preventDefault();
        let validationError = false
        let formErrorObject = {}

        /* validate fields */
        if (!formData.email) {
            formErrorObject["email"] = "Enter email"; 
            validationError = true;
        } else if (!isEmail(formData.email)) {
            formErrorObject["email"] = "Enter valid email"; 
            validationError = true;
        } 

        /* if validation error, setFormError, clear out form and call parent's submit handler with the valid form data */
        if (validationError) {
            setFormError(formErrorObject);  
        } else {
            //TRACE  &&  prtVar("convertedFormData", JSON.stringify(convertedFormData,null,2))
            /* clear out form */
            setFormData(initialFormState);   
            setFormError(initialFormState);  
            /* fire off Parent's callback submit form handler only when form data has been validated */ 
            submitFormHandler(formData);  
            /* close modal */
            handleClose();
        }
    }   

    return (
        <CustomModal showCustomModal={showModal}>
            <div className="nem-modal-container">
                <div className="nem-cancel-button" onClick={handleCancel}>X</div>
                <div className="nem-title">{title}</div>    
                <form className="nem-form-container" onSubmit={handleSubmit}>
                    <input className="nem-input"
                        autoComplete="off"
                        type="text"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="Email Address"
                    />
                    { !formError.email  ?  <div className="nem-error">&nbsp;</div>  :  <div className="nem-error">{formError.email}</div>  }
                    <div style={{display: 'flex', justifyContent: 'center' }}>
                        <SimpleButton buttonText="Done" words={3} color="grey" />
                    </div>
                </form>
            </div>
        </CustomModal>
    )
}

EmailModal.propTypes = {
    showModal:          PropTypes.bool.isRequired,
    closeHandler:       PropTypes.func,
    cancelHandler:      PropTypes.func,
    submitFormHandler:  PropTypes.func,
    title:              PropTypes.string
}

export default EmailModal




// WEBPACK FOOTER //
// ./src/components/modals/EmailModal.js